export const CAL_REFRESH_ERROR_CODE = {
  MissingOrInvalidAuthorizationHeader: "missing_or_invalid_authorization_header",
  InvalidAccessToken: "invalid_access_token",
  CredentialsOwnerMissingCalUserId: "credentials_owner_missing_cal_user_id",
  FailedToRefreshAccessToken: "failed_to_refresh_access_token",
} as const;

export type CalRefreshErrorCode =
  (typeof CAL_REFRESH_ERROR_CODE)[keyof typeof CAL_REFRESH_ERROR_CODE];

export const CAL_TERMINAL_REFRESH_401_CODES = new Set<string>([
  CAL_REFRESH_ERROR_CODE.InvalidAccessToken,
  CAL_REFRESH_ERROR_CODE.CredentialsOwnerMissingCalUserId,
  CAL_REFRESH_ERROR_CODE.MissingOrInvalidAuthorizationHeader,
]);
